const Color = {
    type: String,
    validator: (value) => {
        // The value must match one of these strings
        return [
            'primary',
            'secondary',
            'success',
            'danger',
            'warning',
            'info',
            'dark',
            'light',
            'link',
            'transparent',
            'primary-gradient',
            'secondary-gradient',
            'success-gradient',
            'danger-gradient',
            'warning-gradient',
            'info-gradient',
            'dark-gradient',
            'light-gradient',
        ].includes(value);
    },
};

export { Color };
//# sourceMappingURL=props.js.map
